/**
 * Page parts module
 */
import React, { useEffect, useState } from 'react';
import { FaDoorOpen, FaHome, FaUser } from "react-icons/fa"; // npm i react-icons #see https://github.com/react-icons/react-icons

// App components importation
import { getTime, getWindowWidth } from "../tools";
import { getCall } from '../genericRequests';

/**
 * Represents a common page header
 */
export function Header({ session, title, onOpenPage, onLogout }: PropsType) //extends React.Component<,
// { mandant, hasError: boolean, isLoading: boolean, execTime: number }>
{
    // const [hasError, sethasError] = useState(false);
    // const [isLoading, setisLoading] = useState(false);
    // const [execTime, setexecTime] = useState(0);
    const [mandant, setMandant] = useState(null);

    /**
     * Report an error
     * @param {any} err the error object
     */
    const errorHandler = (err) => {
        // sethasError(true);
        console.error(err.message);
    };

    const getMandant = () => {
        if (!session) return;

        getCall("header/mandant")
            .then(({ data }) => setMandant(data))
            .catch(err => errorHandler(err));
    };

    useEffect(() => {
        getMandant();
    }, []);

    const handleLogout = () => {
        if (!window.onbeforeunload || window.confirm('Some changes have NOT been saved. Log out anyway?')) {
            window.onbeforeunload = null;
            onLogout();
        }
    };

    /**
     * Render the component
     */

    const ww = getWindowWidth();
    const getInitials = (s: string) => s.replace(/[ ,-.]+/g, ' ').trim()
        .split(' ').map((w) => w.charAt(0)).join('')
        .toUpperCase();

    return (
        <div className="w3-white header">
            <div className="w3-container w3-cell" style={{ width: '130px', position: 'relative', top: '-20px' }}>
                <a className="link" title={session ? "Back to home" : undefined}
                    onClick={() => session ? onOpenPage("home") : null}>
                    <img className="w3-image w3-left" src={mandant ? `icons/${mandant}.png` : "icons/empty.png"} />
                </a>
            </div>
            <div className="w3-cell w3-center" style={{ width: `${ww - 250}px` }}>
                <div className="w3-large w3-wide w3-opacity"
                    style={{ color: '#0059b3', margin: '8px', textShadow: '1px 1px 0 #444' }}>
                    <b>Service Hub</b>
                </div>
                <div style={{ marginLeft: '8px' }}><b>{title}</b></div>
            </div>

            <div className="w3-cell w3-center w3-padding-16" style={{ width: '120px' }}>
                {session ?
                    <div>
                        <div style={{ marginBottom: '6px' }}>
                            <a className="link" title="My home" onClick={() => onOpenPage("home")}><FaHome /></a>&nbsp;-&nbsp;
                            <a className="link"
                                title={`${session.user_full}\n` +
                                    `Logged in since ${getTime(session.start)}\n` +
                                    "Open my account settings"}
                                onClick={() => onOpenPage("account")}><FaUser /> <b>{getInitials(session.user_full)}</b></a>
                        </div>
                        <button className="w3-button w3-small w3-round w3-black w3-padding-small w3-hover-red w3-hover-shadow"
                            title="Close the session properly and see you later!" onClick={() => handleLogout()}>
                            <FaDoorOpen /> Logout
                        </button>
                    </div> : null}
            </div>
        </div>
    );
}

type PropsType = {
    session?: {
        secret: string; user_full: string; start;
    };
    title?: string;
    onOpenPage?: (page: string) => void;
    onLogout?: () => void;
};